import { Logo } from '@/components';
import { Swiper } from 'antd-mobile';
import type { ReactNode } from 'react';
import s from './style.module.less';

export type AuthLayoutProps = {
  children: ReactNode;
  /** 内容区最大宽度，默认 350px */
  maxWidth?: number;
  /** 登录页左侧 Banner 图 URL 列表 */
  loginBanners?: string[];
};

/**
 * 登录/注册/忘记密码等认证页面的公共布局
 */
export function AuthLayout(props: AuthLayoutProps) {
  const { children, maxWidth = 420, loginBanners } = props;

  return (
    <div className={s.root}>
      <div className={s.logo}>
        <Logo className={s.logoText} />
      </div>
      {loginBanners && loginBanners.length > 0 ? (
        <Swiper autoplay autoplayInterval={4000} className={s.carousel} loop>
          {loginBanners.map((url) => (
            <Swiper.Item key={url}>
              <div className={s.slide}>
                <img src={url} className={s.slideImg} />
              </div>
            </Swiper.Item>
          ))}
        </Swiper>
      ) : null}
      <div className={s.box} style={{ maxWidth }}>
        {children}
      </div>
    </div>
  );
}
